import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { StaticKeyResponseType } from "../../../../services/api/instances/staticTokenApi/types";
import {
  createStaticTokenReducerBuilder,
  getAllStaticTokensReducerBuilder,
  updateStaticTokenReducerBuilder,
} from "./reducers";
import type { StaticTokenState } from "./types";

const initialState: StaticTokenState = {
  tokens: [],
  isLoading: false,
};

const staticTokenSlice = createSlice({
  name: "staticToken",
  initialState,
  reducers: {
    setTokens: (state, action: PayloadAction<StaticKeyResponseType[]>) => {
      state.tokens = Array.isArray(action.payload) ? action.payload : [];
    },
  },
  extraReducers: (builder) => {
    getAllStaticTokensReducerBuilder(builder);
    createStaticTokenReducerBuilder(builder);
    updateStaticTokenReducerBuilder(builder);
  },
});

export const staticTokenReducers = staticTokenSlice.reducer;
export const { setTokens } = staticTokenSlice.actions;
